/** Assumptions-review API percentages are always human percentage points.
 * 0.5 means 0.5%, never the fractional value 50%. */
export function formatReviewPercent(value: number): string {
  return `${value.toFixed(2).replace(/\.00$/, "")}%`;
}
